<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="countryList">
          <div class="country">
              <span>雨情统计：</span>
          </div>
          <!-- <div class="country">
              <span>时段雨量</span>
          </div> -->
          <div class="country" v-for="(item,index) in rainstatis" :key="index" @click="navcheck(item,index,item.type)">
              <span :class="{'countryon':index==choosed}">{{item.name}}</span>
          </div>
          <!-- <div class="country">
              <span>月雨量</span>
          </div>
          <div class="country">
              <span>年雨量</span>
          </div> -->
      </div>
      <component :is="activeComponent" v-if="componentAlive"></component>
    </div>
  </div>
</template>
<script>
import RainHour from './rainhour'
import DayRain from './dayrain'
import MonthRain from './monthrain'
import YearRain from './yearrain'
import timer from '@/utils/timer'
export default {
  name: 'MonitoringCenter',
  components: {
    RainHour,
    DayRain,
    MonthRain,
    YearRain
  },
  data () {
    return {
      activeComponent: 'RainHour',
      rainstatis: [
        { name: '时段雨量', type: 'RainHour' },
        { name: '日雨量', type: 'DayRain' },
        { name: '月雨量', type: 'MonthRain' },
        { name: '年雨量', type: 'YearRain' }
      ],
      choosed: 0,
      timerFun: '',
      componentAlive: true
    }
  },
  computed: {
  },
  methods: {
    navcheck: function (item, index, type) {
      this.choosed = index
      console.log(type)
      this.activeComponent = type
    },
    compomentReload () {
      this.componentAlive = false
      this.$nextTick(() => {
        this.componentAlive = true
      })
    }
  },
  mounted () {
    this.timerFun = setInterval(this.compomentReload, timer.TIMER_MIN)
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
